// import ZJApp from '../../../api'
import ZJApi from './api.js'
// import ZJConfig from '../../config'
import utils from '../../utils'

const info = {
    service: 'AlarmService',
    controller: 'AlertSender'
};

const methods = [
    'SendDetail',

];

const factory = (Fun) => {
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function (data) {
            return this.post(path, data)
        }
    })
};

const AlarmApi = ZJApi.defineNewApi('AlarmApi', factory);

export default AlarmApi;